class ModalManager {
    constructor() {
        this.storageKey = 'user_session';
        this.cookieKey = 'suppress_modal';
        this.telegramCookieKey = 'suppress_telegram_modal';
        this.defaultSessionData = {
            entry_time: Date.now(),
            form_filled: false,
            modal_shown: false
        };
        this.init();
    }

    init() {
        if (!this.getSessionData()) {
            localStorage.setItem(this.storageKey, JSON.stringify(this.defaultSessionData));
        }
        this.bindEvents();
    }

    getSessionData() {
        return JSON.parse(localStorage.getItem(this.storageKey));
    }

    updateSessionData(newData) {
        const currentData = this.getSessionData();
        const updatedData = { ...currentData, ...newData };
        localStorage.setItem(this.storageKey, JSON.stringify(updatedData));
    }

    setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    bindEvents() {
        $('.js_form_validate').on('click', '.js_valid_form', () => {
            this.updateSessionData({ form_filled: true });
            this.setCookie(this.cookieKey, 'true', 7);
        });

        $(document).on('mouseleave', (e) => {
            const sessionData = this.getSessionData();

            if (sessionData.modal_shown || this.getCookie(this.cookieKey)) return;

            const timeSpent = (Date.now() - sessionData.entry_time) / 1000;
            if (e.clientY <= 0 && timeSpent >= 20 && !sessionData.form_filled) {
                this.showModal();
            }
        });
    }

    showModal() {
        const form = $('.js__buy_one_click');

        if (form.length > 0) {
            const formModal = $('[data-modal=submitFormExit] .js_form_validate');

            formModal.find('[name=guid]').val(form.find('[name=guid]').val());
            formModal.find('[name=id]').val(form.find('[name=id]').val());
            formModal.find('[name=item_type]').val(form.find('[name=item_type]').val());
            formModal.find('[name=quantity]').val(form.find('[name=quantity]').val());
        }

        this.updateSessionData({ modal_shown: true });
        $('footer').append('<button type=button class=modal_open data-modal=submitFormExit></button>');
        $('button[data-modal=submitFormExit]').trigger('click').remove();
    }

    createModal(modalId = 'submitFormExit') {
        if (this.getCookie(this.cookieKey)) {
            return;
        }

        this.showModal();

        $(`[data-modal=${modalId}]`).on('click', '.modal_close, a', () => {
            this.setCookie(this.cookieKey, 'true', 7);
        });
    }

    createTelegramModal(modalId = 'telegramSubscription') {
        if (this.getCookie(this.telegramCookieKey)) {
            return;
        }

        $.post('/service/create-modal', { 'name': 'telegram_subs' }, (data) => {
            if (data.status === 'success') {
                // Устанавливаем куки сразу после показа модалки
                this.setCookie(this.telegramCookieKey, 'true', 7);

                // Добавляем фон и модалку
                this.openBg('js__close_tg_block');
                $('footer').after(data.html);

                // Обработчик закрытия для .js_close_modal, a, .js__close_tg_block
                $(`[data-modal=${modalId}]`).on('click', '.js_close_modal, a, .js__close_tg_block', () => {
                    $('.bg_modal_window').remove();
                    $(`[data-modal=${modalId}]`).remove();
                });

                // Обработчик клика по фону
                $('.bg_modal_window.js__close_tg_block').on('click', () => {
                    $('.bg_modal_window').remove();
                    $(`[data-modal=${modalId}]`).remove();
                });
            }
        });
    }

    openBg(classBlock = '') {
        if ($('.bg_modal_window').length === 0) {
            $('footer').after(`<div class="bg_modal_window ${classBlock}"></div>`);
        }
    }
}

window.createTelegramModal = (modalId = 'telegramSubscription') => {
    new ModalManager().createTelegramModal(modalId);
};

// Initialize when document is ready
$(document).ready(function () {
    if (typeof is_modal !== 'undefined' && is_modal) {
        window.modalManager = new ModalManager();
    }
});